import { render } from "./404Page.vue?vue&type=template&id=6141b863&ts=true"
import script from "./404Page.vue?vue&type=script&lang=ts"
export * from "./404Page.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__